/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-unused-vars */
import React, { useState, ChangeEventHandler } from 'react';
import { ErrorMessage, Form, Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { AlertAdapter, CancelButton, CommonDatePicker, RegularButton } from 'pg-ui-library';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import BenefitsService from 'src/services/benefits.service';
import { t } from 'i18next';
import {
  FormWrapper,
  StyledErrorWrap,
  FooterButtonWrapper,
  Input,
  InputWrapper,
  InputLabel,
  TextAreaInput,
  EnrollDatePickerValidation,
} from '../styles';

import './index.css';

type EnrollmentFormType = {
  name: string;
  eventStartDate: Date;
  eventEndDate: Date;
  planInitialPeriod: Date;
  planEndPeriod: Date;
  message: string;
  disclaimer: string;
};

const EnrollmentFormStepOne: React.FC<{
  values: EnrollmentFormType;
  handleChange: ChangeEventHandler<HTMLInputElement>;
}> = ({ values, handleChange }) => (
  <>
    <span>What would you like to call this open enrollment event?</span>

    <FormWrapper style={{ padding: '60px 0 0 0' }}>
      <InputWrapper>
        <InputLabel>Name</InputLabel>

        <Input
          style={{ width: '60%' }}
          data-cy="enrollment-form-name"
          type="name"
          id="name"
          name="name"
          placeholder="Name..."
          value={values.name}
          onChange={handleChange}
        />
      </InputWrapper>
      <ErrorMessage data-cy="name-error" name="name" component={StyledErrorWrap} />
    </FormWrapper>
  </>
);

const EnrollmentFormStepTwo: React.FC<{
  values: EnrollmentFormType;
  handleChange: ChangeEventHandler<HTMLInputElement>;
}> = ({ values, handleChange }) => (
  <>
    <span>What plan period this enrollment event cover?</span>

    <span style={{ marginTop: '20px' }}>
      Any Benefit versions with begin and end dates that fall within this range will be available for your selection for
      this enrollment event
    </span>

    <FormWrapper>
      <div style={{ display: 'flex', gap: '40px', marginTop: '20px' }}>
        <InputWrapper>
          <InputLabel>Start Date</InputLabel>
          <CommonDatePicker
            id="planInitialPeriod"
            name="planInitialPeriod"
            label=""
            onChange={handleChange}
            placeholderText="MM/DD/YY"
          />
          <div style={{ position: 'absolute', marginTop: '7%' }}>
            {values.planInitialPeriod > values.planEndPeriod ? (
              <EnrollDatePickerValidation style={{ color: 'red', fontSize: '8pt' }}>
                {t('openEnrollment.modal.periodStart')}
              </EnrollDatePickerValidation>
            ) : (
              ''
            )}
          </div>
          <InputLabel>End Date</InputLabel>
          <CommonDatePicker
            id="planEndPeriod"
            name="planEndPeriod"
            label=""
            onChange={handleChange}
            placeholderText="MM/DD/YY"
          />
          <div
            style={{
              position: 'absolute',
              marginTop: '7%',
              marginLeft: '48.7%',
            }}
          >
            {values.planEndPeriod < values.planInitialPeriod ? (
              <EnrollDatePickerValidation>{t('openEnrollment.modal.periodEnd')}</EnrollDatePickerValidation>
            ) : (
              ''
            )}
          </div>
        </InputWrapper>
      </div>
    </FormWrapper>

    <span style={{ marginTop: '20px' }}>
      The Benefit Effective Start date will be set to the Plan Start Date above. If you would like to change this date
      once the benefits are effective , please go to the employee’s Employee Maintenance Card{'>'}
      Employee Benefits to select a new date
    </span>
  </>
);

const EnrollmentFormStepTree: React.FC<{
  values: EnrollmentFormType;
  handleChange: ChangeEventHandler<HTMLInputElement>;
}> = ({ values, handleChange }) => (
  <>
    <span>When employees can make enrollment changes?</span>

    <FormWrapper>
      <div style={{ display: 'flex', gap: '40px', marginTop: '20px' }}>
        <InputWrapper>
          <InputLabel>Start Date</InputLabel>
          <CommonDatePicker
            id="eventStartDate"
            name="eventStartDate"
            label=""
            onChange={handleChange}
            placeholderText="MM/DD/YY"
          />
          <div style={{ position: 'absolute', marginTop: '7%' }}>
            {values.eventStartDate > values.eventEndDate ? (
              <EnrollDatePickerValidation>{t('openEnrollment.modal.eventStart')}</EnrollDatePickerValidation>
            ) : (
              ''
            )}
          </div>
          <InputLabel>End Date</InputLabel>
          <CommonDatePicker
            id="eventEndDate"
            name="eventEndDate"
            label=""
            onChange={handleChange}
            placeholderText="MM/DD/YY"
          />
          <div
            style={{
              position: 'absolute',
              marginTop: '7%',
              marginLeft: '48.9%',
            }}
          >
            {values.eventEndDate < values.eventStartDate ? (
              <EnrollDatePickerValidation>{t('openEnrollment.modal.eventEnd')}</EnrollDatePickerValidation>
            ) : (
              ''
            )}
          </div>
        </InputWrapper>
      </div>
    </FormWrapper>
  </>
);

const EnrollmentFormStepFour: React.FC<{
  values: EnrollmentFormType;
  handleChange: ChangeEventHandler<HTMLTextAreaElement>;
}> = ({ values, handleChange }) => (
  <>
    <span>How would you like to welcome your employees to this enrollment event?</span>

    <FormWrapper>
      <div style={{ display: 'flex', gap: '40px', marginTop: '20px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1',
            gap: '10px',
          }}
        >
          <InputLabel>Message</InputLabel>
          <TextAreaInput
            id="message"
            name="message"
            value={values.message}
            onChange={handleChange}
            placeholder="Message..."
            rows={10}
          />
        </div>
      </div>
    </FormWrapper>
  </>
);

const EnrollmentFormStepFive: React.FC<{
  values: EnrollmentFormType;
  handleChange: ChangeEventHandler<HTMLInputElement>;
}> = ({ values, handleChange }) => (
  <>
    <span>Is there a disclaimer statement your employees need to sign electronically when making their elections?</span>

    <span style={{ marginTop: '20px' }}>
      *If the disclaimer isn’t necessary, the Passive Enrollment will be applied to it
    </span>

    <FormWrapper>
      <div style={{ display: 'flex', gap: '40px', marginTop: '20px' }}>
        <div>
          <label className="form-control">
            <input type="radio" id="disclaimer" name="disclaimer" onChange={handleChange} value="yes" />
            Yes, my employees are required to sign a disclaimer before making enrollment elections.
          </label>

          <label className="form-control">
            <input type="radio" id="disclaimer" name="disclaimer" onChange={handleChange} checked value="no" />
            No, my employees are not required to sign a disclaimer before making enrollment elections.*
          </label>
        </div>
      </div>
    </FormWrapper>
  </>
);

export const EnrollmentForm: React.FC<{
  onClose: Function;
}> = ({ onClose }) => {
  const queryClient = useQueryClient();
  const [step, setStep] = useState(1);
  const companyId = useTypedSelector(state => state.config.data?.config?.selectedCompanyId) || '';

  const schema = yup.object({
    name: yup.string().required(t('global.form.required')).max(255),
    eventStartDate: yup.date().required(t('global.form.required')),
    eventEndDate: yup.date().required(t('global.form.required')),
    planInitialPeriod: yup.date().required(t('global.form.required')),
    planEndPeriod: yup.date().required(t('global.form.required')),
    message: yup.string().required(t('global.form.required')).max(255),
    disclaimer: yup.string().required(t('global.form.required')),
  });

  const nextStep = () => {
    if (step >= 5) {
      onClose();
    } else {
      setStep(actualStep => actualStep + 1);
    }
  };

  const stepBack = () => {
    if (step <= 1) {
      onClose();
    } else {
      setStep(actualStep => actualStep - 1);
    }
  };

  const mutationCreate = useMutation(
    (variables: EnrollmentFormType) =>
      BenefitsService.createNewEnrollmentEvent({
        name: variables.name,
        eventStartDate: variables.eventStartDate.toISOString(),
        eventEndDate: variables.eventEndDate.toISOString(),
        planInitialPeriod: variables.planInitialPeriod.toISOString(),
        planEndPeriod: variables.planEndPeriod.toISOString(),
        message: variables.message,
        disclaimer: variables.disclaimer === 'yes',
        companyId,
      }),
    {
      onSuccess: () => {
        AlertAdapter('Enrollment event created', 'success');
        queryClient.invalidateQueries(['benefits/enrollment-historic']);
        onClose();
      },
      onError: (error: AxiosError) => {
        AlertAdapter(error.response?.data.message ?? 'Failed to create a new event', 'error');
      },
    }
  );

  const onSubmit = (values: EnrollmentFormType) => {
    mutationCreate.mutate(values);
  };

  const disableNextStep = (values: EnrollmentFormType) => {
    if (
      step === 3 &&
      (values.planInitialPeriod > values.planEndPeriod || values.eventStartDate > values.eventEndDate)
    ) {
      return true;
    }

    if (step === 2 && values.planInitialPeriod > values.planEndPeriod) {
      return true;
    }
    return false;
  };

  return (
    <Formik
      initialValues={{
        name: '',
        eventStartDate: new Date() || '',
        eventEndDate: new Date() || '',
        planInitialPeriod: new Date() || '',
        planEndPeriod: new Date() || '',
        message: '',
        disclaimer: 'no',
      }}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      {({ handleChange, isSubmitting, errors, values, isValid }) => (
        <Form
          style={{
            display: 'flex',
            flex: '1',
            flexDirection: 'column',
            flexWrap: 'wrap',
            alignContent: 'space-between',
          }}
        >
          {step === 1 && <EnrollmentFormStepOne values={values} handleChange={handleChange} />}
          {step === 2 && <EnrollmentFormStepTwo values={values} handleChange={handleChange} />}
          {step === 3 && <EnrollmentFormStepTree values={values} handleChange={handleChange} />}
          {step === 4 && <EnrollmentFormStepFour values={values} handleChange={handleChange} />}
          {step === 5 && <EnrollmentFormStepFive values={values} handleChange={handleChange} />}

          <FooterButtonWrapper>
            <div>
              <RegularButton
                data-cy="enrollment-cancel-button"
                type="button"
                disabled={isSubmitting || step === 1}
                onClick={stepBack}
              >
                {t('global.button.back')}
              </RegularButton>
            </div>
            <div>
              {step === 5 ? (
                <RegularButton
                  data-cy="enrollment-submit-button"
                  type="button"
                  disabled={isSubmitting}
                  onClick={() => {
                    if (!isValid) {
                      AlertAdapter('You need to fill all form fields', 'warning');
                      return;
                    }
                    onSubmit(values);
                  }}
                >
                  {t('global.form.save')}
                </RegularButton>
              ) : (
                <RegularButton
                  data-cy="enrollment-submit-button"
                  type="button"
                  disabled={disableNextStep(values)}
                  onClick={nextStep}
                >
                  {t('global.button.next')}
                </RegularButton>
              )}
            </div>
          </FooterButtonWrapper>
        </Form>
      )}
    </Formik>
  );
};
